import { httpRequest } from '@common/util/api-common.util';

class FavoritosApi {
  static GetFavoritoRequisicaoById() {
    ///RequisicaoProtocolo
  }

  static GetFavoritoRequisicaoByUsuarioId(tipo, usuarioId) {
    /// passar o id usuário logado no sistema

    return httpRequest(`favoritousuario/${tipo}/usuario/${usuarioId}`, 'GET').then((resp) => {
      return resp.data;
    });    
  }

  static PostFavoritoRequisicaoProtocolo(tipo, favoritos) {
    return httpRequest(`favoritousuario/${tipo}`, 'POST', favoritos).then((resp) => {
      return resp.data;
    });
  }

  static SetFavoritoDefault(favorito) {
    return httpRequest(`favoritousuario/${favorito}`, 'PATCH').then((response) => {
      return response.data;
    });
  }

  static DeletarFavorito(favorito) {
    return httpRequest(`favoritousuario/${favorito}`, 'Delete').then((response) => {
      return response.data;
    });
  }
}

export default FavoritosApi;



// WEBPACK FOOTER //
// ./src/componentes/Favoritos/favoritosApi.js